// extracted by mini-css-extract-plugin
var _1 = "Zoom_image__364c3";
export { _1 as "image" }
